var map = {
	"./back_head.svg": 39431,
	"./back_head_active.svg": 1312,
	"./back_left_buttocks.svg": 61889,
	"./back_left_buttocks_active.svg": 5251,
	"./back_left_elbow.svg": 61794,
	"./back_left_elbow_active.svg": 55919,
	"./back_left_foot.svg": 47209,
	"./back_left_foot_active.svg": 98570,
	"./back_left_hand.svg": 64006,
	"./back_left_hand_active.svg": 13707,
	"./back_left_lower_arm.svg": 39831,
	"./back_left_lower_arm_active.svg": 52976,
	"./back_left_lower_back.svg": 62134,
	"./back_left_lower_back_active.svg": 18587,
	"./back_left_lower_leg.svg": 28333,
	"./back_left_lower_leg_active.svg": 8454,
	"./back_left_neck.svg": 74620,
	"./back_left_neck_active.svg": 43481,
	"./back_left_upper_arm.svg": 14912,
	"./back_left_upper_arm_active.svg": 94805,
	"./back_left_upper_back.svg": 32407,
	"./back_left_upper_back_active.svg": 63152,
	"./back_left_upper_leg.svg": 24550,
	"./back_left_upper_leg_active.svg": 24811,
	"./back_lower_body.svg": 71043,
	"./back_lower_body_active.svg": 14404,
	"./back_neck.svg": 91728,
	"./back_neck_active.svg": 96229,
	"./back_right_buttocks.svg": 43807,
	"./back_right_buttocks_active.svg": 80072,
	"./back_right_elbow.svg": 41585,
	"./back_right_elbow_active.svg": 32770,
	"./back_right_foot.svg": 82376,
	"./back_right_foot_active.svg": 5933,
	"./back_right_hand.svg": 49215,
	"./back_right_hand_active.svg": 4456,
	"./back_right_lower_arm.svg": 52412,
	"./back_right_lower_arm_active.svg": 6201,
	"./back_right_lower_back.svg": 15315,
	"./back_right_lower_back_active.svg": 75444,
	"./back_right_lower_leg.svg": 10290,
	"./back_right_lower_leg_active.svg": 90687,
	"./back_right_neck.svg": 73989,
	"./back_right_neck_active.svg": 34478,
	"./back_right_upper_arm.svg": 8847,
	"./back_right_upper_arm_active.svg": 3064,
	"./back_right_upper_back.svg": 46078,
	"./back_right_upper_back_active.svg": 57171,
	"./back_right_upper_leg.svg": 65349,
	"./back_right_upper_leg_active.svg": 13198,
	"./back_upper_body.svg": 21018,
	"./back_upper_body_active.svg": 87959,
	"./front_head.svg": 3057,
	"./front_head_active.svg": 52962,
	"./front_left_foot.svg": 12795,
	"./front_left_foot_active.svg": 95276,
	"./front_left_hand.svg": 52872,
	"./front_left_hand_active.svg": 59885,
	"./front_left_knee.svg": 32814,
	"./front_left_knee_active.svg": 4931,
	"./front_left_lower_arm.svg": 117,
	"./front_left_lower_arm_active.svg": 26110,
	"./front_left_lower_body.svg": 97981,
	"./front_left_lower_body_active.svg": 81494,
	"./front_left_lower_leg.svg": 60971,
	"./front_left_lower_leg_active.svg": 77756,
	"./front_left_upper_arm.svg": 49046,
	"./front_left_upper_arm_active.svg": 63547,
	"./front_left_upper_body.svg": 89388,
	"./front_left_upper_body_active.svg": 60841,
	"./front_left_upper_leg.svg": 36092,
	"./front_left_upper_leg_active.svg": 38809,
	"./front_lower_body.svg": 69109,
	"./front_lower_body_active.svg": 34398,
	"./front_neck.svg": 81246,
	"./front_neck_active.svg": 98611,
	"./front_right_foot.svg": 94170,
	"./front_right_foot_active.svg": 12567,
	"./front_right_hand.svg": 4865,
	"./front_right_hand_active.svg": 3333,
	"./front_right_knee.svg": 78303,
	"./front_right_knee_active.svg": 16264,
	"./front_right_lower_arm.svg": 16138,
	"./front_right_lower_arm_active.svg": 44775,
	"./front_right_lower_body.svg": 90624,
	"./front_right_lower_body_active.svg": 78389,
	"./front_right_lower_leg.svg": 10336,
	"./front_right_lower_leg_active.svg": 76149,
	"./front_right_upper_arm.svg": 36565,
	"./front_right_upper_arm_active.svg": 9438,
	"./front_right_upper_body.svg": 36189,
	"./front_right_upper_body_active.svg": 95990,
	"./front_right_upper_leg.svg": 97419,
	"./front_right_upper_leg_active.svg": 77436,
	"./front_upper_body.svg": 98244,
	"./front_upper_body_active.svg": 85713,
	"./line.svg": 15013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84671;